//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React              from 'react';
import _                  from 'lodash';
import I18n               from 'i18next';
import PropTypes          from '@/components/PropTypes';
import styles             from './styles.module.scss';
import IconType           from '@/components/stateless/atomic/Icon/IconType';
import { IconTextButton } from '@/components/stateless/atomic/IconTextButton';
import { Logo }           from '@/components/stateless/atomic/Logo';

export class Component extends React.Component {
    render() {
        const { onClick } = this.props;

        return (
            <div
                className={styles.joinCompanyHeader}
            >
                <div className={styles.joinNowText}>
                    <span>
                        {I18n.t('join')}
                    </span>
                    <span>
                        {I18n.t('now')}
                    </span>
                </div>
                <Logo className={styles.logo} />
                <div
                    className={styles.joinButton}
                >
                    <IconTextButton
                        active={true}
                        onClick={onClick}
                        iconType={IconType.check}
                        text={I18n.t('join')}
                    />
                </div>
            </div>
        );
    }
}

Component.propTypes = {
    company: PropTypes.object,
    onClick: PropTypes.func,
};

Component.defaultProps = {
    company: null,
    onClick: _.noop,
};

export const JoinNowHeader = Component;

export default Component;
